import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@material-ui/core';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import StockGlobalProductForm from 'forms/StockGlobalProductForm';
import { getGlobalProduct } from 'services/stockServices';
import { GlobalProduct } from 'types/models/StockReceipt';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedGlobalProduct } = React.useContext(EditStockModuleContext);

  const [globalProduct, setGlobalProduct] = React.useState<GlobalProduct | null>(selectedGlobalProduct ?? null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (!selectedGlobalProduct) {
      history.replace('/private/stock/global-products');
      return;
    }

    let mounted = true;
    const globalProductId = selectedGlobalProduct.id;

    async function loadDetail() {
      try {
        const detail = await getGlobalProduct(globalProductId);
        if (mounted) {
          setGlobalProduct(detail);
        }
      } catch {
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    }

    loadDetail();

    return () => {
      mounted = false;
    };
  }, [selectedGlobalProduct, history]);

  if (!selectedGlobalProduct) return <></>;

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 48,
        }}
      >
        <CircularProgress />
        <span style={{ marginLeft: 16, alignSelf: 'center' }}>{t('loading')}</span>
      </div>
    );
  }

  return <StockGlobalProductForm globalProduct={globalProduct ?? undefined} />;
};
